// utils/getBIC.js
export const BIC_MAP = {
  "0003": "BDEPESM1XXX",
  "0004": "BANDESSSXXX",
  "0009": "FICDESM1XXX",
  "0011": "ALLFESMMXXX",
  "0013": "SLBKESBBXXX",
  "0015": "CATAESBBXXX",
  "0016": "CENTESMM",
  "0019": "DEUTESBBXXX",
  "0021": "BCNDESM1XXX",
  "0024": "BALEES22XXX",
  "0030": "BSCHESMMXXX",
  "0031": "ETCHES2GXXX",
  "0036": "BSABESBBXXX",
  "0038": "BCARESMMXXX",
  "0042": "BGUIES22XXX",
  "0043": "BHROESM2XXX",
  "0046": "BSCHESMMXXX",
  "0048": "CGDIES2VXXX",
  "0049": "BSCHESMMXXX",
  "0050": "BCIOESMMXXX",
  "0056": "JOVEESBBXXX",
  "0057": "BVADESMMXXX",
  "0058": "BNPAESMMXXX",
  "0059": "MADRESMMXXX",
  "0061": "BMARES2MXXX",
  "0062": "BASKES2BXXX",
  "0063": "BMAPESM1XXX",
  "0065": "BARCESMMXXX",
  "0069": "BAMUES22XXX",
  "0072": "PSTRESMMXXX",
  "0073": "OPENESMMXXX",
  "0075": "POPUESMMXXX",
  "0076": "PROGESMM",
  "0078": "BAPUES22XXX",
  "0081": "BSABESBBXXX",
  "0082": "CASTES2SXXX",
  "0083": "RENBESMMXXX",
  "0085": "BDERESMMXXX",
  "0086": "NORTESMMXXX",
  "0087": "SIBBESBBXXX",
  "0088": "PSTRESMMXXX",
  "0089": "CGDIES2CXXX",
  "0094": "BVALESMMXXX",
  "0095": "VASCES2PXXX",
  "0096": "PROAESMMXXX",
  "0097": "GALIES2VXXX",
  "0100": "BVICES21XXX",
  "0101": "CBANESBBXXX",
  "0104": "EXTEESMMXXX",
  "0106": "LOYDESMMXXX",
  "0107": "BNLIESM1XXX",
  "0108": "SOGEESMMXXX",
  "0109": "DEEEESM1XXX",
  "0111": "BAFOESMM",
  "0113": "INBBESM1XXX",
  "0118": "ASTUESMMXXX",
  "0121": "OCBAESM1XXX",
  "0122": "CITIES2XXXX",
  "0125": "BAOFESM1XXX",
  "0127": "BBVAESMMXXX",
  "0128": "BKBKESMMXXX",
  "0129": "INALESM1XXX",
  "0130": "CGDIESMMXXX",
  "0131": "UCJAES2MXXX",
  "0132": "PRNEESM1XXX",
  "0133": "MIKBESB1XXX",
  "0136": "AREBESMMXXX",
  "0137": "BADIESMMXXX",
  "0138": "BKOAES22XXX",
  "0142": "BPMEESBBXXX",
  "0144": "PARBESMXXXX",
  "0145": "DEUTESM1XXX",
  "0147": "MGTCESMXXXX",
  "0149": "BNPAESMMXXX",
  "0150": "NWBKESMXXXX",
  "0151": "CHASESM3XXX",
  "0152": "BPLCESMMXXX",
  "0154": "BSUIESMMXXX",
  "0155": "BRASESMMXXX",
  "0156": "ABNAESMMXXX",
  "0159": "COBAESMXXXX",
  "0160": "BOTKESMXXXX",
  "0161": "BKTRESM1XXX",
  "0162": "MIDLESMMXXX",
  "0163": "UNCRESMMXXX",
  "0164": "BSCEESMMXXX",
  "0166": "BESPESMMXXX",
  "0167": "GEBAESMMXXX",
  "0168": "BBRUESMXXXX",
  "0169": "NACNESMMXXX",
  "0171": "SMITESMXXXX",
  "0172": "CCFRESMMXXX",
  "0174": "BCITESMMXXX",
  "0177": "MITKESM1XXX",
  "0178": "ROYCESM1XXX",
  "0179": "AGRIESMM",
  "0180": "ILBKESMMXXX",
  "0182": "BBVAESMMXXX",
  "0184": "BEDFESM1XXX",
  "0185": "UIJOESMMXXX",
  "0186": "BFIVESBBXXX",
  "0188": "ALCLESMMXXX",
  "0189": "IBJTESM1XXX",
  "0190": "BBPIESMMXXX",
  "0195": "SANWESM1XXX",
  "0196": "WELAESMMXXX",
  "0197": "BESCESMMXXX",
  "0198": "BCOEESMMXXX",
  "0199": "CRESESMMXXX",
  "0200": "PRVBESB1XXX",
  "0201": "NAPBESMMXXX",
  "0202": "BNARESMMXXX",
  "0203": "FUJIJPJTXXX",
  "0205": "DECRESM1XXX",
  "0206": "DKBBESM1XXX",
  "0208": "CRLEESMMXXX",
  "0209": "ABBKESM1XXX",
  "0210": "MDBOESM1XXX",
  "0211": "PROAESMMXXX",
  "0212": "COBFFRPPXXX",
  "0213": "CARIESMMXXX",
  "0215": "DBOLESM1XXX",
  "0216": "CMCIESMMXXX",
  "0217": "HLFXESMMXXX",
  "0218": "FCEFESM1XXX",
  "0219": "BMCEESMMXXX",
  "0220": "FIOFESM1XXX",
  "0221": "PRABESMMXXX",
  "0223": "GEECESB1XXX",
  "0224": "SCFBESMMXXX",
  "0225": "FIEIESM1XXX",
  "0226": "UBSWESMMXXX",
  "0227": "UNOEESM1XXX",
  "0228": "IXIUESM1XXX",
  "0229": "POPLESMMXXX",
  "0231": "DSBLESMMXXX",
  "0232": "INVLESMMXXX",
  "0233": "POPIESMMXXX",
  "0234": "CCOCESMMXXX",
  "0235": "PIESESM1XXX",
  "0236": "LOYIESMMXXX",
  "0237": "CSURES2CXXX",
  "0238": "PSTRESMMXXX",
  "0239": "EVOBESMMXXX",
  "0240": "BCCAESMMXXX",
  "0241": "AYGBESMMXXX",
  "0243": "CRESESMMXXX",
  "0486": "TRESES2BXXX",
  "0487": "GBMNESMMXXX",
  "0488": "BFASESMMXXX",
  "0489": "EMACESMMXXX",
  "1000": "ICROESMMXXX",
  "1001": "BCAEESMM",
  "1004": "BCLEESMMXXX",
  "1113": "BSUDESM1XXX",
  "1116": "SCSIESM1XXX",
  "1127": "SCBLESM1XXX",
  "1150": "ETICES21XXX",
  "1156": "IRVTESM1XXX",
  "1164": "ESBFESM1XXX",
  "1168": "BNACESM1XXX",
  "1173": "COURESB1XXX",
  "1182": "HYVEESM1XXX",
  "1191": "HANDES21XXX",
  "1193": "PKBSES21XXX",
  "1196": "AEEVESM1XXX",
  "1197": "BILLESB1XXX",
  "1199": "CRGEESM1XXX",
  "1209": "ABCMESM1XXX",
  "1210": "REDEESM1XXX",
  "1221": "PNBMESM1XXX",
  "1222": "PCIBESM1XXX",
  "1224": "RHRHESM1XXX",
  "1227": "BSSAESB1XXX",
  "1231": "BOCAES21XXX",
  "1233": "BCMAESM1XXX",
  "1234": "PRBAESM1XXX",
  "1236": "HELAESM1XXX",
  "1238": "BIMEESM1XXX",
  "1239": "GENOESM1XXX",
  "1240": "LOFPESB1XXX",
  "1241": "STOLESM1XXX",
  "1242": "SOLAESB1XXX",
  "1245": "BEIVESM1XXX",
  "1248": "WAFAESM1XXX",
  "1249": "NPBSES21XXX",
  "1251": "IHZUES21XXX",
  "1252": "VONTESM1XXX",
  "1255": "AARBESM1XXX",
  "1273": "IKBDESM1XXX",
  "1302": "BBVAESMMXXX",
  "1451": "AGRIESB1XXX",
  "1452": "UBSWESMMXXX",
  "1453": "PASCESMMXXX",
  "1454": "NEWGESM1XXX",
  "1457": "LLISESM1XXX",
  "1459": "PRABESMMXXX",
  "1460": "CRESESMMXXX",
  "1462": "ASSCESM1XXX",
  "1463": "PSABESM1XXX",
  "1464": "NFFSESM1XXX",
  "1465": "INGDESMMXXX",
  "1466": "FRANESM1XXX",
  "1467": "EHYPESMXXXX",
  "1468": "EEHDESM1XXX",
  "1469": "SHSAESM1XXX",
  "1470": "BPIPESM1XXX",
  "1471": "ROYCESM1XXX",
  "1472": "UCSSESM1XXX",
  "1473": "PRIBESMXXXX",
  "1474": "CITIESMXXXX",
  "1475": "CCSEESM1XXX",
  "1478": "MLIBESM1XXX",
  "1479": "NATXESMMXXX",
  "1480": "VOWAES21XXX",
  "1485": "BOFAES2XXXX",
  "1488": "PICTESMMXXX",
  "1490": "SELFESMMXXX",
  "1491": "TRIOESMMXXX",
  "1494": "BCITESMMXXX",
  "1497": "ESSIESMMXXX",
  "1502": "IKBDESM1XXX",
  "1505": "ARABESMMXXX",
  "1506": "MLCBESM1XXX",
  "1508": "RCINFRPPXXX",
  "1522": "EFGBESMMXXX",
  "1524": "UBIBESMMXXX",
  "1525": "BCDMESM1XXX",
  "1534": "KBLXESMMXXX",
  "1538": "ICBKESMMXXX",
  "1544": "BACAESMMXXX",
  "1545": "AGRIESMMXXX",
  "1583": "REVOESM2XXX",
  "1586": "TRBKDEBBXXX",
  "2000": "CECAESMMXXX",
  "2010": "CECAESMM010",
  "2013": "CESCESBBXXX",
  "2017": "CECAESMM017",
  "2018": "CECAESMMXXX",
  "2024": "CECAESMM024",
  "2030": "CECAESMM030",
  "2031": "CECAESMM031",
  "2032": "CECAESMM032",
  "2037": "CECAESMM037",
  "2038": "CAIXESBBXXX",
  "2040": "CECAESMM040",
  "2041": "CECAESMM041",
  "2043": "CECAESMM043",
  "2045": "CECAESMM045",
  "2048": "CECAESMM048",
  "2051": "CECAESMM051",
  "2052": "CECAESMM052",
  "2054": "CANVES2PXXX",
  "2056": "CECAESMM056",
  "2066": "CECAESMM066",
  "2069": "CECAESMM069",
  "2071": "CECAESMM071",
  "2073": "CECAESMM073",
  "2074": "CECAESMM074",
  "2077": "CVALESVVXXX",
  "2080": "CAGLESMMXXX",
  "2081": "CECAESMM081",
  "2085": "CAZRES2ZXXX",
  "2086": "CECAESMM086",
  "2090": "CAAMES2AXXX",
  "2091": "CAGLESMMXXX",
  "2092": "CECAESMM092",
  "2094": "CECAESMM094",
  "2095": "BASKES2BXXX",
  "2096": "CSPAES2LXXX",
  "2097": "BASKES2BXXX",
  "2098": "CECAESMM098",
  "2099": "CECAESMM099",
  "2100": "CAIXESBBXXX",
  "2101": "CGGKES22XXX",
  "2103": "UCJAES2MXXX",
  "2104": "CSSOES2SXXX",
  "2105": "CECAESMM105",
  "2106": "CECAESMM106",
  "2108": "CSPAES2L108",
  "3001": "BCOEESMM001",
  "3005": "BCOEESMM005",
  "3007": "BCOEESMM007",
  "3008": "BCOEESMM008",
  "3009": "BCOEESMM009",
  "3016": "BCOEESMM016",
  "3017": "BCOEESMM017",
  "3018": "BCOEESMM018",
  "3020": "BCOEESMM020",
  "3021": "BCOEESMM021",
  "3022": "BCOEESMM022",
  "3023": "BCOEESMM023",
  "3025": "CDENESBBXXX",
  "3029": "CCRIES2A029",
  "3035": "CLPEES2MXXX",
  "3045": "CCRIES2A045",
  "3056": "BCOEESMM056",
  "3058": "CCRIES2AXXX",
  "3059": "BCOEESMM059",
  "3060": "BCOEESMM060",
  "3061": "CRCPES2CXXX",
  "3062": "BCOEESMM062",
  "3063": "BCOEESMM063",
  "3064": "BCOEESMM064",
  "3066": "BCOEESMM066",
  "3067": "BCOEESMM067",
  "3070": "BCOEESMM070",
  "3076": "BCOEESMM076",
  "3078": "BCOEESMM078",
  "3080": "BCOEESMM080",
  "3081": "BCOEESMM081",
  "3082": "CCRIES2A082",
  "3083": "BCOEESMM083",
  "3084": "CVRVES2BXXX",
  "3085": "BCOEESMM085",
  "3089": "BCOEESMM089",
  "3092": "BCOEESMM092",
  "3093": "BCOEESM1093",
  "3094": "CCRIES2A094",
  "3095": "CCRIES2A095",
  "3096": "BCOEESMM096",
  "3098": "BCOEESMM098",
  "3102": "CCRIES2A102",
  "3104": "BCOEESMM104",
  "3105": "CCRIES2A105",
  "3110": "CCRIES2A110",
  "3111": "BCOEESMM111",
  "3112": "CCRIES2A112",
  "3113": "BCOEESMM113",
  "3114": "BCOEESMM114",
  "3115": "BCOEESMM115",
  "3117": "BCOEESMM117",
  "3118": "CCRIES2A118",
  "3119": "CCRIES2A119",
  "3121": "CCRIES2A121",
  "3123": "CCRIES2A123",
  "3127": "BCOEESMM127",
  "3128": "BCOEESMM128",
  "3130": "BCOEESMM130",
  "3134": "BCOEESMM134",
  "3135": "CCRIES2A135",
  "3138": "BCOEESMM138",
  "3140": "BCOEESMM140",
  "3144": "BCOEESMM144",
  "3146": "CCCVESM1XXX",
  "3147": "BCOEESMM147",
  "3150": "BCOEESMM150",
  "3152": "CCRIES2A152",
  "3157": "CCRIES2A157",
  "3159": "BCOEESMM159",
  "3160": "CCRIES2A160",
  "3161": "BCOEESMM161",
  "3162": "BCOEESMM162",
  "3165": "CCRIES2A165",
  "3166": "BCOEESMM166",
  "3172": "CCOCESMMXXX",
  "3174": "BCOEESMM174",
  "3179": "CCRIES2A179",
  "3181": "BCOEESM1181",
  "3183": "CASDESBBXXX",
  "3186": "CCRIES2A186",
  "3187": "BCOEESMM187",
  "3189": "BCOEESMM189",
  "3190": "BCOEESMM190",
  "3191": "BCOEESMM191",
  "3669": "IVALESMMXXX",
  "3682": "GVCBESBBETB",
  "6852": "BMEUESM1XXX",
  "8233": "CSFAESM1XXX",
  "8512": "UCINESMMXXX",
  "8835": "SBFCESMMXXX",
  "9000": "ESPBESMMXXX",
  "9020": "IPAYESMMXXX",
  "9094": "MEFFESBBXXX",
  "9096": "IBRCESMMXXX",
};

/**
 * Devuelve el BIC correspondiente a un código de banco (4 cifras del IBAN)
 * @param {string} codigoBanco
 * @returns {string} BIC o "DESCONOCIDO"
 */
export function obtenerBICdesdeBanco(codigoBanco) {
  return BIC_MAP[codigoBanco] || "DESCONOCIDO";
}
